import React, { useEffect, useState } from 'react';
import { Award, X } from 'lucide-react';

const AchievementNotification = ({ achievement, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Animate in
    setTimeout(() => setIsVisible(true), 100);
    
    // Auto close after 5 seconds
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onClose, 300);
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div
      className={`fixed top-24 right-6 z-[9999] transform transition-all duration-300 ${
        isVisible ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'
      }`}
    >
      <div className="bg-gradient-to-r from-yellow-500/20 to-orange-500/20 border-2 border-yellow-500/50 rounded-xl p-4 shadow-2xl backdrop-blur-md max-w-sm">
        <div className="flex items-start gap-3">
          {/* Icon */}
          <div className="flex-shrink-0">
            <div className="w-12 h-12 bg-yellow-500/20 rounded-full flex items-center justify-center animate-bounce">
              <Award className="w-6 h-6 text-yellow-400" />
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between mb-1">
              <h4 className="text-lg font-bold text-yellow-400">
                Achievement Unlocked!
              </h4>
              <button
                onClick={() => {
                  setIsVisible(false);
                  setTimeout(onClose, 300);
                }}
                className="text-gray-400 hover:text-white transition-colors"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
            <p className="text-2xl font-bold text-white mb-1">
              {achievement.icon} {achievement.title}
            </p>
            <p className="text-sm text-gray-300 mb-2">
              {achievement.description}
            </p>
            <div className="flex items-center gap-2">
              <div className="px-3 py-1 bg-yellow-500/20 rounded-full">
                <span className="text-xs font-semibold text-yellow-400">
                  +{achievement.points} points
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AchievementNotification;
